import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";
import { canAccessApp } from "./codiumAccessGate";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
// Gate de acceso ANTES de renderizar: evita el flash del editor a visitantes no
// autenticados. Si no procede, canAccessApp() ya ha redirigido a login.
canAccessApp().then((allowed) => {
  if (!allowed) {
    return;
  }
  root.render(
    <StrictMode>
      <ExcalidrawApp />
    </StrictMode>,
  );
});
